<template>
  <v-app>
    <v-app-bar app height="100">
      <v-toolbar-title class="headline text-uppercase">
        <router-link to="/">
          <img
            :src="require('@/assets/img/eduroam.png')"
            style="height: 80px"
            class="hidden-xs-only"
          />
          <img
            :src="require('@/assets/img/eduroam.png')"
            style="height: 50px"
            class="hidden-sm-and-up"
          />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn fab icon class="hidden-md-and-up" small @click.stop="drawer = !drawer">
        <v-icon medium>fas fa-bars</v-icon>
      </v-btn>

      <v-toolbar-items class="hidden-sm-and-down">
        <div
          v-for="(item, i) in items"
          :key="i"
          style="height: 0px; margin-top: 47px; box-shadow: 0px 0px; "
        >
          <v-list class="pa-0">
            <router-link :to="item.link" class="nav-act">
              <v-list-item class="pl-2 pr-2">
                <v-list-item-title class="body-2">
                  <p class="meni_txt font_size" v-html="item.title.toUpperCase()"></p>
                </v-list-item-title>
              </v-list-item>
            </router-link>
          </v-list>
        </div>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-title class="headline text-uppercase">
        <a href="https://sumit.sum.ba" target="_blank">
          <img :src="require('@/assets/img/sumit.svg')" style="height: 80px" class="hidden-xs-only" />
          <img
            :src="require('@/assets/img/sumit.svg')"
            style="height: 60px"
            class="hidden-sm-and-up"
          />
        </a>
      </v-toolbar-title>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list class="pa-1 pt-4 pb-4" >
        <v-list-item>
          <router-link to="/"><img style="height: 55px" :src="require('@/assets/img//sumit.svg')" /></router-link>

          <v-list-item-content class="pl-3">
            <v-list-item-title>Izbornik</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list>
        <div v-for="item in items" :key="item.title">
          
            <v-list-item >
              <!-- <v-list-tile-avatar class="list-link">
                <v-icon >{{ item.icon }}</v-icon>
              </v-list-tile-avatar> -->

              <v-list-item-content>
                <v-list-item-title class="list-link"><router-link  :to="item.link" > {{ item.title }}</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-footer app dark color="#084776" height="45px">
      <v-layout column color="#084776" class="white--text text-center">
        <v-flex md12>
          <v-card-text class="footer-title pa-0" style="font-size: 15px;">
            Copyright © <strong><a
                style="text-decoration: none;"
                class="footer-link"
                href="https://sumit.sum.ba/"
                target="_blank"
              >SUMIT</a>
            </strong> 2019
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    drawer: null,
    items: [
      {
        title: "Za korisnike",
        link: "/korisnici"
      },
      {
        title: "Za davatelje usluga",
        link: "/davatelji_usluga"
      },
      {
        title: "Dokumentacija",
        link: "/dokumentacija"
      },
      {
        title: "Stanje usluga",
        link: "#"
      },
      {
        title: "Kontakt",
        link: "/kontakt"
      }
    ]
  })
};
</script>
